import { render, staticRenderFns } from "./workModal.vue?vue&type=template&id=c8968332&"
import script from "./workModal.vue?vue&type=script&lang=ts&"
export * from "./workModal.vue?vue&type=script&lang=ts&"
import style0 from "./workModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports